<template>
  <div id="header" class="bg-light">
    <div :class="{'container': screenWidth>=992, 'container-fluid': screenWidth<992}">
      <nav class="navbar navbar-expand-md navbar-light bg-light">
        <router-link class="navbar-brand p-0" :to="{name: 'home'}">
          <img src="@/assets/images/logo.svg" alt="logo" />
        </router-link>
        <button class="navbar-toggler" type="button" @click.prevent="show = !show">
          <i class="material-icons">menu</i>
        </button>
        <transition name="slide">
          <div
            id="navbarContent"
            class="collapse navbar-collapse"
            v-if="screenWidth>=768 || screenWidth<768 && show"
            :class="{'show': show}"
          >
            <ul class="navbar-nav ml-auto h-100">
              <li
                  class="nav-item"
                  :class="{active: currentPage === 'journal'}"
                >
                <router-link class="nav-link" :to="{name:'journal'}">奇蹟會訊</router-link>
              </li>
              <li
                class="nav-item"
                :class="{active: currentPage === 'activities' || currentPage === 'article'}"
              >
                <router-link class="nav-link" :to="{name:'activities'}">活動記錄</router-link>
              </li>
              <li class="nav-item" :class="{active: currentPage === 'service'}">
                <router-link class="nav-link" :to="{name:'service'}">服務項目</router-link>
              </li>
              <li
                class="nav-item"
                :class="{active: currentPage === 'volunteer' || currentPage === 'registration'}"
              >
                <router-link class="nav-link" :to="{name: 'volunteer'}">志工招募</router-link>
              </li>
              <li class="nav-item" :class="{active: currentPage === 'donation'}">
                <router-link class="nav-link" :to="{name:'donation'}">捐款資訊</router-link>
              </li>
              <li class="nav-item" :class="{active: currentPage === 'aboutUs'}">
                <router-link class="nav-link" :to="{name: 'aboutUs'}">關於我們</router-link>
              </li>
                 <a
                 v-if="screenWidth>768"
                  :href="info.FB"
                  class="nav-link d-flex align-items-center justify-content-center px-1"
                  target="_blank"
                >
                  <img class="fb-logo w-60 float-right" src="@/assets/images/Fill1.svg" alt="FB_logo" />
                </a>
                  <a
                 v-if="screenWidth>768"
                  :href="info.Instagram"
                  class="nav-link d-flex align-items-center justify-content-center px-1"
                  target="_blank"
                >
                  <img class="fb-logo w-60 float-right" src="@/assets/images/ig_logo_color.svg" alt="Instagram_logo" />
                </a>
              <li
                v-if="screenWidth<768"
                class="nav-item"
                :class="{active: currentPage === 'reservation'}"
              >
                <router-link class="nav-link" :to="{name: 'reservation'}">預約參訪</router-link>
              </li>
              <li
                v-if="screenWidth<768"
                class="nav-item"
                :class="{active: currentPage === 'career'}"
              >
                <router-link class="nav-link" :to="{name: 'career'}">徵才資訊</router-link>
              </li>
              <li v-if="screenWidth<768" class="nav-item">
                <router-link class="nav-link" :to="{name: 'home', params:{id: 'transport'}}">交通資訊</router-link>
              </li>
              <li v-if="screenWidth<768" class="nav-item">
                <router-link class="nav-link" :to="{name:'aboutUs', params:{id:'environment'}}">環境場地</router-link>
              </li>
              <li v-if="screenWidth<768" class="nav-item">
                <a
                  :href="info.FB"
                  class="nav-link d-flex align-items-center justify-content-center px-1"
                  target="_blank"
                >
                  <img class="fb-logo mr-10" src="@/assets/images/fb-logo.svg" alt="FB_logo" />臉書專頁
                </a>
              </li>
              <li v-if="screenWidth<768" class="nav-item">
                <a
                  :href="info.Instagram"
                  class="nav-link d-flex align-items-center justify-content-center px-1"
                  target="_blank"
                >
                  <img class="ig-logo mr-2" style="width:25px" src="@/assets/images/ig_logo.svg" alt="Instagram_logo" />Instagram
                </a>
              </li>
              <li v-if="screenWidth<768" class="nav-item border-0">
                <a
                  :href="info.donate"
                  class="nav-link d-flex align-items-center justify-content-center px-1"
                  target="_blank"
                >
                  <img class="fb-logo mr-10" src="@/assets/images/donate.svg" alt="donate_icon" />前往捐款
                </a>
              </li>
            </ul>
          </div>
        </transition>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Header',
  computed: {
    ...mapGetters(['screenWidth']),
    currentPage() {
      return this.$route.name;
    },
  },
  data() {
    return {
      show: false,
      info: {
        FB:
          'https://www.facebook.com/%E4%B8%BB%E9%A1%A7%E4%BF%AE%E5%A5%B3%E6%9C%83%E5%A5%87%E8%B9%9F%E4%B9%8B%E5%AE%B6-314038992080726/',
        Instagram: 'https://www.instagram.com/miraclehome321/',
        donate: 'https://miracle-esc.eoffering.org.tw/',
      },
    };
  },
  watch: {
    screenWidth() {
      if (this.screenWidth > 768) {
        this.show = false;
      }
    },
    $route() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/all.scss';

#header {
  border-bottom: 4px solid $sub-primary;
  nav {
    &.navbar {
      padding: 7px 15px;
      @media (min-width: 576px) {
        padding: 10px;
      }
      .navbar-brand {
        a{
          margin: 0px;
        }
        img:first-of-type {
          height: 50px;
          width: auto;
          @media (min-width: 576px) {
            height: 70px;
          }
        }
        img:nth-of-type(2) {
          height: 55px;
          width: auto;
        }
      }
    }
    .navbar-toggler {
      border: none;
      i {
        font-size: 36px;
        color: $sub-primary;
      }
    }
    #navbarContent {
      @media (max-width: 767px) {
        overflow-x: hidden;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 1px;
        }
      }
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: $primary;
      top: 68px;
      @media (min-width: 576px) {
        top: 94px;
      }
      li {
        @media (max-width: 767px) {
          width: 60%;
          padding: 10px 0;
          margin: 0 auto;
          transition: 0.5s ease-out;
          &:hover,
          &.active {
            background: $sub-primary;
          }
        }
        border-bottom: 2px dashed white;
        a {
          font-size: 18px;
          color: white;
          text-align: center;
        }
      }
      @media (min-width: 768px) {
        position: static;
        background-color: #f8f9fa;
        li {
          padding: 0 7px;
          margin: 5px 0;
          border-right: 1px solid rgba(0, 0, 0, 0.05);
          border-bottom: none;
          transition: 0.5s ease-out;
          position: relative;
          @media (min-width: 992px) {
            padding: 0 10px;
          }
          a.nav-link {
            @media (min-width: 992px) {
              font-size: 18px;
          }
            padding: 0;
            font-size: 15px;
            color: $secondary;
          }
          &:last-of-type {
            border: none;
          }
          &:hover,
          &.active {
            z-index: 1;
            a {
              color: white;
            }
            &::before {
              position: absolute;
              content: '';
              background: linear-gradient(
                180deg,
                rgba(darken($primary, 30%), 0.8),
                rgba($primary, 0.8)
              );
              top: -32px;
              bottom: -31px;
              left: -1px;
              right: -1px;
              z-index: -2;
              animation: showing 0.3s ease-out;
            }
            &::after {
              position: absolute;
              content: '';
              background-color: $sub-primary;
              top: 48px;
              bottom: -31px;
              left: -1px;
              right: -1px;
              z-index: -1;
              animation: showUp 0.2s ease-out;
            }
          }
        }
      }
    }
  }
  @keyframes showUp {
    from {
      top: 50px;
    }
    to {
      top: 48px;
    }
  }
  @keyframes showing {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .slide-enter-active {
    transition: 0.3s ease-in;
  }
  .slide-leave-active {
    transition-duration: 0.3s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }
  .slide-enter-to,
  .slide-leave {
    height: 100%;
    overflow: hidden;
  }
  .slide-enter,
  .slide-leave-to {
    overflow: hidden;
    height: 0;
  }

}
</style>
